import React, { useCallback } from 'react';
import { getTotalFailedJobCost } from 'service/service';
import ComputeHierarchyBase, { FetchServiceParams } from './ComputeHierarchyBase';

const PRESERVE_FILTER_KEY = 'failed_job_cost_filters';

const FailedJobCost = () => {
    const serviceFunc = useCallback((params: FetchServiceParams) => {
        return getTotalFailedJobCost({
            startDate: params.startDate,
            endDate: params.endDate,
            env: params.env,
            sector: params.sector,
            location: params.location,
            selectedDateInString: params.apiDateRangeKey,
            page: params.page,
            limit: params.pageSize,
        });
    }, []);

    return (
        <ComputeHierarchyBase
            serviceFunc={serviceFunc}
            pageTitle="Total Failed Job Cost"
            tableTitlePrefix="Total Failed Job Cost"
            columnLabel="Cost"
            isCurrency={true}
            preserveFilterKey={PRESERVE_FILTER_KEY}
            detailPath="/databricksADB/failed-jobs-cost-details"
            tableType="cost-details-ver"
            breadcrumbLabel="Job Analysis"
            breadcrumbPath="/databricksADB/jobsADB"
            additionalNavState={{ resultState: 'FAILED' }}
        />
    );
};

export default FailedJobCost;